import React, { useCallback, useEffect, useState } from 'react';
import * as yup from 'yup';
import { useFormik } from 'formik';
import {
  TextField,
  Dialog,
  DialogActions,
  DialogTitle,
  DialogContent,
  Grid,
  Typography,
  CircularProgress,
} from '@material-ui/core';

import { useStyles, Form } from './styles';
import { IMaplinkRequest, useMaplink } from '../../hooks/maplink';

import { Button } from '../../../../components/Button';

interface IProps {
  open: boolean;
  onClose: () => void;
}

export const Maplink: React.FC<IProps> = (props) => {
  const classes = useStyles();
  const { loadMaplink, saveMaplink } = useMaplink();
  const [loadingButton, setLoadingButton] = useState(false);
  const [loadingMaplink, setLoadingMaplink] = useState(true);
  const [data, setData] = useState<IMaplinkRequest>({
    clientId: '',
    clientSecret: '',
  });

  useEffect(() => {
    async function loadIntegration(): Promise<void> {
      try {
        const response = await loadMaplink();

        if (!response) return;

        setData({
          ...response,
        });
      } catch (error) {
        console.log(error);
      } finally {
        setLoadingMaplink(false);
      }
    }
    if (props.open) loadIntegration();
  }, [loadMaplink, props.open]);

  const validationSchema = yup.object().shape({
    clientId: yup.string(),
    clientSecurity: yup.string(),
  });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      ...data,
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      setLoadingButton(true);

      try {
        await saveMaplink(values);
        props.onClose();
      } catch (error) {
        console.log(error);
      }

      setLoadingButton(false);
    },
  });

  const handleClose = useCallback(() => {
    props.onClose();
    formik.resetForm();
    setLoadingMaplink(true);
  }, [props, formik]);

  return (
    <Dialog
      fullWidth
      maxWidth="sm"
      open={props.open}
      onClose={handleClose}
      aria-labelledby="form-dialog-title"
    >
      <DialogTitle id="form-dialog-title">MAPLINK</DialogTitle>
      <DialogContent>
        <Form
          onSubmit={formik.handleSubmit}
          noValidate
          className={classes.form}
        >
          <Grid container spacing={3}>
            {loadingMaplink ? (
              <Grid item xs={12}>
                <Typography component="div" align="center">
                  <CircularProgress />
                </Typography>
              </Grid>
            ) : (
              <>
                <Grid item xs={12} sm={6}>
                  <TextField
                    variant="outlined"
                    size="small"
                    required
                    fullWidth
                    label="ClientId"
                    id="clientId"
                    name="clientId"
                    value={formik.values.clientId}
                    onChange={formik.handleChange}
                    error={
                      formik.touched.clientId && Boolean(formik.errors.clientId)
                    }
                    helperText={
                      formik.touched.clientId && formik.errors.clientId
                    }
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    variant="outlined"
                    size="small"
                    required
                    fullWidth
                    label="ClientSecret"
                    id="clientSecret"
                    name="clientSecret"
                    value={formik.values.clientSecret}
                    onChange={formik.handleChange}
                    error={
                      formik.touched.clientSecret &&
                      Boolean(formik.errors.clientSecret)
                    }
                    helperText={
                      formik.touched.clientSecret && formik.errors.clientSecret
                    }
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </Grid>
              </>
            )}
          </Grid>
        </Form>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="inherit">
          Fechar
        </Button>

        <Button
          onClick={() => formik.handleSubmit()}
          color="secondary"
          variant="contained"
          loading={loadingButton}
        >
          Salvar
        </Button>
      </DialogActions>
    </Dialog>
  );
};
